import axios from 'axios'
import join from 'url-join'

// Auth is now fully local to our own backend (routes/authn.js) — the central
// aa-vision service has been removed. The API base ("apir") is derived from
// the page origin instead of being resolved via the old company lookup, so
// there is no bootstrap round-trip before login.

let token = localStorage.getItem('token')

const updateToken = () => {
  token = localStorage.getItem('token')
}

const deriveApir = () => {
  // Explicit override — set via REACT_APP_API_BASE in package.json scripts for
  // local dev, where the origin (localhost) isn't a real customer backend.
  if (process.env.REACT_APP_API_BASE) return process.env.REACT_APP_API_BASE
  // Production: bundle is served from the customer's own VPS, so the API
  // lives at the same origin. This is what makes the app multi-tenant.
  return `${window.location.origin}/api`
}

export let apir = deriveApir()
export let cinfo = null
const haxios = axios.create()
const isAbsoluteURLRegex = /^(?:\w+:)\/\//

// Login against our own backend. Returns { token, user, must_reset } on
// success (and caches the identity as cinfo), or null on bad credentials.
export const getToken = async (username, password) => {
  try {
    const res = await axios.post(
      `${apir}/auth/login`,
      { Username: username, Password: password },
      { headers: { 'Content-Type': 'application/json' } },
    )
    if (res.data && res.data.token) {
      localStorage.setItem('token', res.data.token)
      updateToken()
      cinfo = res.data.user || null
      return res.data
    }
    return null
  } catch (error) {
    return null
  }
}

// Current identity (merged company + operator), from GET /auth/me.
export const getCinfo = async () => {
  if (cinfo) return cinfo
  updateToken()
  if (!token) return null
  try {
    const res = await haxios.get('/auth/me')
    cinfo = (res && res.user) || null
    return cinfo
  } catch (e) {
    return null
  }
}

export const getApir = async () => apir

export const clearCachedData = () => {
  cinfo = null
  token = null
  localStorage.removeItem('token')
  updateToken()
}

// Partial reset — keeps the token in localStorage but forces cinfo to be
// re-fetched. Used during silent re-auth.
export const resetSessionCache = () => {
  cinfo = null
  updateToken()
}

haxios.interceptors.request.use(
  async (config) => {
    updateToken()
    if (token) {
      config.headers.token = token
      config.headers.Authorization = `Bearer ${token}`
    }

    // BDM endpoints expect x-user-inits to identify the actor.
    const inits = localStorage.getItem('userInits')
    if (inits) config.headers['x-user-inits'] = inits

    if (!isAbsoluteURLRegex.test(config.url)) {
      config.url = join(apir, config.url)
    }

    return config
  },
  (error) => Promise.reject(error),
)

haxios.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    if (!error.response) return Promise.reject(error)

    if (error.response.status === 401) {
      clearCachedData()
      if (window.location.pathname !== '/login') window.location.href = '/login'
      // Still reject. Resolving here would hand callers `undefined` as if the
      // request had succeeded — a save that 401s would show "Saved" and never
      // reach the server.
      return Promise.reject(error)
    }

    return Promise.reject(error)
  },
)

export default haxios
